import { DefaultError, useQuery } from "@tanstack/react-query";
import { apiClient } from "utils";
import { useResponseHandler } from "utils/service/responseHandler";
import { ISpotifyStatisticsQuery, ISpotifyStatisticsResponse } from "./types";

export const useGetSpotifyStatistics = (
  query: ISpotifyStatisticsQuery,
  enabled?: boolean
) => {
  const { responseHandler } = useResponseHandler();

  return useQuery<ISpotifyStatisticsResponse, DefaultError>({
    queryKey: ["spotify-statistics", query],
    async queryFn() {
      const params = JSON.parse(JSON.stringify(query));

      const response = await apiClient({
        method: "GET",
        url: "SpotifyStatistics",
        params
      });

      const data = await responseHandler<ISpotifyStatisticsResponse>(response, {
        groupName: "useGetSpotifyStatistics",
        onNotFound: () => {},
      });

      return data;
    },
    enabled,
    staleTime: 5 * 60 * 1000,
    refetchOnWindowFocus: false,
  });
};
